module.exports = __webpack_public_path__ + "media/src/img/hero-flowers-left-a0d31e0b6adf565e49f3befd9f2352dc.png";